// extracted by mini-css-extract-plugin
export default {"slider":"Brand_slider__gKhFP"};